import { OutlinedButton } from "../../components/buttons/OutlinedButton";
import RecordingIcon from "../../icons/Bottombar/RecordingIcon";
import recordingBlink from "../../static/animations/recording-blink.json";
import { Constants, useMeeting } from "@videosdk.live/react-sdk";
import useIsRecording from "../../hooks/useIsRecording";
import { useEffect, useMemo, useRef } from "react";
import { gettext } from '@resuelve/malinchex';
import { i18nTexts } from "../../i18n";


export function TopBar ({ topBarHeight }) {
  const { meeting } = useMeeting() || {};
  const RecordingBTN = () => {
    const { startRecording, stopRecording, recordingState } = useMeeting();
    const defaultOptions = {
      loop: true,
      autoplay: true,
      animationData: recordingBlink,
      rendererSettings: {
        preserveAspectRatio: "xMidYMid slice",
      },
      height: 64,
      width: 160,
    };

    const isRecording = useIsRecording();

    const isRecordingRef = useRef(isRecording);

    useEffect(() => {
      isRecordingRef.current = isRecording;
    }, [isRecording]);

    const { isRequestProcessing } = useMemo(
      () => ({
        isRequestProcessing:
          recordingState === Constants.recordingEvents.RECORDING_STARTING ||
          recordingState === Constants.recordingEvents.RECORDING_STOPPING,
      }),
      [recordingState]
    );

    const _handleClick = () => {
      const isRecording = isRecordingRef.current;

      if (isRecording) {
        stopRecording();
      } else {
        startRecording();
      }
    };

    return (
      <OutlinedButton
        Icon={RecordingIcon}
        onClick={_handleClick}
        isFocused={isRecording}
        buttonText={!isRecording 
          ? gettext(i18nTexts.meeting_screen.buttons.recording_btn.text.not_recording) 
          : gettext(i18nTexts.meeting_screen.buttons.recording_btn.text.is_recording)
        }
        tooltip={
            recordingState === Constants.recordingEvents.RECORDING_STARTED
              ? gettext(i18nTexts.meeting_screen.buttons.recording_btn.tooltip.recording_started) 
              : recordingState === Constants.recordingEvents.RECORDING_STARTING
              ? gettext(i18nTexts.meeting_screen.buttons.recording_btn.tooltip.recording_starting)
              : recordingState === Constants.recordingEvents.RECORDING_STOPPED
              ? gettext(i18nTexts.meeting_screen.buttons.recording_btn.tooltip.recording_stopped)
              : recordingState === Constants.recordingEvents.RECORDING_STOPPING
              ? gettext(i18nTexts.meeting_screen.buttons.recording_btn.tooltip.recording_stopping)
              : gettext(i18nTexts.meeting_screen.buttons.recording_btn.tooltip.recording_stopped)
        }
        lottieOption={isRecording ? defaultOptions : null}
        isRequestProcessing={isRequestProcessing}
        disabled={true}
      />
    );
  };

  return (
    <div className="flex items-center justify-center lg:justify-end pt-2 lg:px-2 xl:px-6 pb-0 px-2 z-10">
      {meeting?.localParticipant?.mode === Constants.modes.SEND_AND_RECV && (
        <RecordingBTN />
      )}
    </div>
  );
}
